import { httpClient } from '../lib/http.interceptor';
import { unifiedStorage } from '../lib/unified-storage';

export interface User {
  id: string;
  email: string;
  name: string;
  type: 'admin' | 'agency' | 'promoter';
  avatar?: string;
  description?: string;
  emailVerified: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateProfileDto {
  name: string;
  description?: string;
}

class ProfileService {
  async getProfile(): Promise<User> {
    try {
      console.log('[ProfileService] Calling getProfile...');
      const tokens = unifiedStorage.getTokens();
      const token = tokens?.accessToken;
      console.log('[ProfileService] Token available:', !!token);
      
      // Add Authorization header directly as fallback
      const headers: any = {};
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
        console.log('[ProfileService] Adding Authorization header directly:', headers['Authorization']);
      }
      
      const response = await httpClient.get('/auth/me', { headers });
      console.log('[ProfileService] Response received:', response.status);
      return response.data;
    } catch (error: any) {
      console.error('[ProfileService] Failed to fetch profile:', {
        status: error.response?.status,
        statusText: error.response?.statusText,
        url: error.config?.url,
        headers: error.config?.headers,
        data: error.response?.data
      });
      throw error;
    }
  }

  async updateProfile(data: UpdateProfileDto): Promise<User> {
    try {
      const tokens = unifiedStorage.getTokens();
      const token = tokens?.accessToken;
      const headers: any = token ? { 'Authorization': `Bearer ${token}` } : {};
      
      const response = await httpClient.put('/auth/me', data, { headers });
      return response.data;
    } catch (error) {
      console.error('Failed to update profile:', error);
      throw error;
    }
  }

  async uploadAvatar(file: File): Promise<{ avatarUrl: string }> {
    try {
      const formData = new FormData();
      formData.append('file', file);  // Changed from 'avatar' to 'file'
      
      const tokens = unifiedStorage.getTokens();
      const token = tokens?.accessToken;
      const response = await httpClient.post('/auth/avatar', formData, {
        headers: {
          'Authorization': token ? `Bearer ${token}` : '',
          'Content-Type': 'multipart/form-data',
        },
      });
      return response.data;
    } catch (error) {
      console.error('Failed to upload avatar:', error);
      throw error;
    }
  }

  async logout(): Promise<void> {
    try {
      const tokens = unifiedStorage.getTokens();
      const token = tokens?.accessToken;
      const headers: any = token ? { 'Authorization': `Bearer ${token}` } : {};
      
      await httpClient.post('/auth/logout', {}, { headers });
    } catch (error) {
      console.error('Failed to logout:', error);
      throw error;
    }
  }
}

export const profileService = new ProfileService();